import { render, staticRenderFns } from "./PersonOrganiztioninfo.vue?vue&type=template&id=5fd8133c"
import script from "./PersonOrganiztioninfo.vue?vue&type=script&lang=js"
export * from "./PersonOrganiztioninfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports